/* global chrome */
import React, { useState } from 'react'
import useDrivePicker from '../react-google-drive-picker'
// eslint-disable-next-line import/no-named-as-default
import Button from '../shared/components/Button'
import icon from '../shared/img/icon-128.png'
import S from './ConfigureGDrive.module.css'

export default function Picker() {
  const [openPicker] = useDrivePicker()
  const [selectedFile, setSelectedFile] = useState( null )

  // environment variables will change slightly
  const handleOpenPicker = () => {
    const handleSelection = ( result ) => {
      if ( result?.action === 'picked' && result?.docs[0] ) {
        setSelectedFile( result?.docs[0] )
        chrome.runtime.sendMessage(
          'oibkmifcgjkkfadphlimdeaephokhjkc',
          {
            type : 'actions.fileSelected',
            medicareSaver : true,
            file : { id : result?.docs[0].id, name : result?.docs[0].name },
          },
        )
      }
      // TODO: send data to the extension
    }
    openPicker( {
      clientId : process.env.REACT_APP_DRIVE_API_CLIENT_ID,
      appId : process.env.REACT_APP_DRIVE_API_APP_ID,
      viewId : 'DOCS',
      showUploadView : true,
      showUploadFolders : true,
      supportDrives : true,
      multiselect : false,
      callbackFunction : handleSelection,
      customScopes : ['https://www.googleapis.com/auth/drive.file'],
    } )
  }

  let content
  if ( selectedFile ) {
    content = (
      <div className={S.helperText}>
        Thanks for picking a file! You may now close this tab.
      </div>
    )
  } else {
    content = (
      <>
        <div className={S.helperText}>
          Clicking the button below will open a Google Drive file picker.
          Once a file is Selected you&#39;ll
          be free to close this tab
        </div>
        <div className={S.buttonContainer}>
          <Button scheme="primary" className={S.start} onClick={handleOpenPicker}>Click Here to Select a File</Button>
        </div>
      </>
    )
  }
  return (
    <div className={S.container}>
      <div className={S.content}>
        <div className={S.titleContainer}>
          <img height="40px" src={icon} alt="Script Keeper" />
          <h1 className={S.title}>Select an Existing File</h1>
        </div>
        {content}
      </div>
    </div>
  )
}
